import React, { useEffect, useState } from "react";
import CustomModal from "../../components/Modal";
import { useForm } from "react-hook-form";
import ExerciseFormFields, { createExerciseMods } from "../../components/ExerciseFormFields";

const Modal = ({ modal, setModal, handleSubmit: handleSubmitModal, edificio }) => {
  const disabled = modal.action === "ADD" ? false : modal.data.ESTADO === 1 ? false : true;
  const [modsData, setModsData] = useState([]);
  const { register, errors, handleSubmit } = useForm({
    defaultValues: modal.data,
  });
  const onSubmit = handleSubmit((data) => handleSubmitModal(data, modsData));

  useEffect(() => {
    setModsData(createExerciseMods(modal.data));
  }, [modal.show, modal.data]);

  return (
    <CustomModal
      show={modal.show}
      title={modal.action === "ADD" ? "Agregar Ejercicio" : `Editar ${modal.data.NOMBRE}`}
      setModal={setModal}
      handleSubmit={onSubmit}
      size="md"
    >
      <form onSubmit={onSubmit}>
        <ExerciseFormFields
          building={edificio}
          values={modal.data}
          modsData={modsData}
          onModsChange={setModsData}
          register={register}
          errors={errors}
          disabled={disabled}
        />
        <input type="submit" style={{ display: "none" }} />
      </form>
    </CustomModal>
  );
};

export default Modal;
